import { render, staticRenderFns } from "./uploaded-by-presenter.vue?vue&type=template&id=134c3b8c&scoped=true&"
import script from "./uploaded-by-presenter.vue?vue&type=script&lang=js&"
export * from "./uploaded-by-presenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134c3b8c",
  null
  
)

export default component.exports